<div
  class="flex items-center justify-center w-full h-full"
  [ngStyle]="{ 'min-height': minHeight }"
  role="progressbar"
  aria-busy="true"
  aria-label="Loading...">
  <mat-spinner [diameter]="size" [class.muted]="muted"></mat-spinner>
</div>
